import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

// Generate a deterministic dark color for a given key so colors are stable across renders
function getDarkColorForKey(key) {
  // FNV-1a 32-bit hash with avalanche finalizer for good dispersion
  let hash = 0x811c9dc5;
  for (let i = 0; i < key.length; i++) {
    hash ^= key.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  // Final mixing (inspired by Murmur3 finalizer)
  hash ^= hash >>> 16;
  hash = Math.imul(hash, 0x85ebca6b);
  hash ^= hash >>> 13;
  hash = Math.imul(hash, 0xc2b2ae35);
  hash ^= hash >>> 16;

  const unsigned = hash >>> 0;
  const hue = unsigned % 360; // 0-359
  const saturation = 60 + (unsigned % 30); // 60%-89%
  const lightness = 24 + ((unsigned >>> 8) % 14); // 24%-37% (keeps it dark)
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

export default function CategoriesGraph({ categories }) {
  const data = {
    labels: [""], // single horizontal bar
    datasets: Object.keys(categories).map((c, i) => ({
      label: c,
      data: [categories[c]],
      backgroundColor: getDarkColorForKey(c),
      barPercentage: 1.0,
      categoryPercentage: 1.0,
      // Visual gap between stacked segments using a border the color of the background
      borderColor: "#ffffff",
      borderSkipped: false,
      borderWidth:
        i === 0
          ? { top: 0, right: 0, bottom: 0, left: 0 }
          : { top: 0, right: 0, bottom: 0, left: 1 },
    })),
  };

  const totalValue = Object.values(categories).reduce((sum, c) => sum + c, 0);

  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        padding: 8,
        callbacks: {
          label: (ctx) => `${ctx.raw} ${ctx.dataset.label}`,
        },
      },
    },
    layout: { padding: 0 },
    scales: {
      x: {
        stacked: true,
        display: false,
        min: 0,
        max: totalValue,
        grace: 0,
        grid: { display: false, drawBorder: false },
        ticks: { display: false },
      },
      y: {
        stacked: true,
        display: false,
        grid: { display: false, drawBorder: false },
        ticks: { display: false },
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div style={{ width: "100%", height: 49 }}>
      <Bar
        data={data}
        options={options}
        style={{ width: "100%", borderRadius: 4 }}
      />
    </div>
  );
}
